export const COMPETENCE_TYPE_TECHNOLOGY = 'technology'; // Технологии
export const COMPETENCE_TYPE_SKILL = 'skill'; // Навыки
export const COMPETENCE_TYPE_SUBJECT = 'subject'; // Предметная область
export const COMPETENCE_TYPE_ID_TECHNOLOGY = 1; // Технологии
export const COMPETENCE_TYPE_ID_SKILL = 2; // Навыки
export const COMPETENCE_TYPE_ID_SUBJECT = 3; // Предметная область

export const getTypeId = (type) => {
  switch (type) {
    case COMPETENCE_TYPE_TECHNOLOGY:
      return COMPETENCE_TYPE_ID_TECHNOLOGY;
    case COMPETENCE_TYPE_SKILL:
      return COMPETENCE_TYPE_ID_SKILL;
    case COMPETENCE_TYPE_SUBJECT:
      return COMPETENCE_TYPE_ID_SUBJECT;
  }
};
